import { defineRouting } from 'next-intl/routing'

const isDevelopment = process.env.NODE_ENV === 'development'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'no', 'se', 'dk'],
  // Used when no locale matches
  defaultLocale: 'en',
  localeDetection: false,
  localePrefix: isDevelopment ? 'always' : 'never',
  ...(isDevelopment
    ? {}
    : {
        domains: [
          {
            // domain: 'dev.firsthotels.com',
            domain: 'www.firsthotels.com',
            defaultLocale: 'en',
            locales: ['en'],
          },
          {
            // domain: 'dev.firsthotels.no',
            domain: 'www.firsthotels.no',
            defaultLocale: 'no',
            locales: ['no'],
          },
          {
            // domain: 'dev.firsthotels.dk',
            domain: 'www.firsthotels.dk',
            defaultLocale: 'dk',
            locales: ['dk'],
          },
          {
            // domain: 'dev.firsthotels.se',
            domain: 'www.firsthotels.se',
            defaultLocale: 'se',
            locales: ['se'],
          },
        ],
      }),
  pathnames: {
    '/': '/',
    '/[slug]': '/[slug]',
    // '/[...slug]': '/[...slug]',
    '/privacy-policy': '/privacy-policy',
    '/terms': '/terms',
    '/booking-conditions': '/booking-conditions',
    '/cookies': '/cookies',
    '/conference': {
      en: '/conference',
      no: '/konferanse',
      se: '/konferens',
      dk: '/konference',
    },
    '/hotels': {
      en: '/hotels',
      no: '/hoteller',
      se: '/hotell',
      dk: '/hoteller',
    },
    '/hotels/[slug]': {
      en: '/hotels/[slug]',
      no: '/hoteller/[slug]',
      se: '/hotell/[slug]',
      dk: '/hoteller/[slug]',
    },
    '/hotels/[country]': {
      en: '/hotels/[country]',
      no: '/hoteller/[country]',
      se: '/hotell/[country]',
      dk: '/hoteller/[country]',
    },
    '/hotels/[country]/[city]': {
      en: '/hotels/[country]/[city]',
      no: '/hoteller/[country]/[city]',
      se: '/hotell/[country]/[city]',
      dk: '/hoteller/[country]/[city]',
    },
    '/hotels/[country]/[city]/[hotel]': {
      en: '/hotels/[country]/[city]/[hotel]',
      no: '/hoteller/[country]/[city]/[hotel]',
      se: '/hotell/[country]/[city]/[hotel]',
      dk: '/hoteller/[country]/[city]/[hotel]',
    },
    '/hotels/[country]/[city]/[hotel]/conferences-meetings': {
      en: '/hotels/[country]/[city]/[hotel]/conferences-meetings',
      no: '/hoteller/[country]/[city]/[hotel]/konferanser-moter',
      se: '/hotels/[country]/[city]/[hotel]/konferens-moten',
      dk: '/hotels/[country]/[city]/[hotel]/konferencer-moder',
    },
    '/hotels/[country]/[city]/[hotel]/[event]': {
      en: '/hotels/[country]/[city]/[hotel]/[event]',
      no: '/hoteller/[country]/[city]/[hotel]/[event]',
      se: '/hotels/[country]/[city]/[hotel]/[event]',
      dk: '/hotels/[country]/[city]/[hotel]/[event]',
    },
    '/map': {
      en: '/map',
      no: '/kart',
      se: '/karta',
      dk: '/kort',
    },
    '/offers': {
      en: '/offers',
      no: '/tilbud',
      se: '/erbjudanden',
      dk: '/tilbud',
    },
    '/things-to-do': {
      en: '/things-to-do',
      no: '/aktiviteter',
      se: '/aktiviteter',
      dk: '/aktiviteter',
    },
    '/offers/[slug]': {
      en: '/offers/[slug]',
      no: '/tilbud/[slug]',
      se: '/erbjudanden/[slug]',
      dk: '/tilbud/[slug]',
    },
    '/offers/hotel/[slug]': {
      en: '/offers/hotel/[slug]',
      no: '/tilbud/hotell/[slug]',
      se: '/erbjudanden/hotell/[slug]',
      dk: '/tilbud/hotell/[slug]',
    },
    '/things-to-do/[slug]': {
      en: '/things-to-do/[slug]',
      no: '/aktiviteter/[slug]',
      se: '/aktiviteter/[slug]',
      dk: '/aktiviteter/[slug]',
    },
    '/vacancies': {
      en: '/vacancies',
      no: '/stillinger',
      se: '/jobb',
      dk: '/stillinger',
    },
    '/vacancies/[slug]': {
      en: '/vacancies/[slug]',
      no: '/stillinger/[slug]',
      se: '/jobb/[slug]',
      dk: '/stillinger/[slug]',
    },
    '/press': {
      en: '/press',
      no: '/presse',
      se: '/press',
      dk: '/presse',
    },
    '/press/[slug]': {
      en: '/press/[slug]',
      no: '/presse/[slug]',
      se: '/press/[slug]',
      dk: '/presse/[slug]',
    },
    '/first-member-terms-conditions': {
      en: '/first-member-terms-conditions',
      no: '/first-member-vilkaar',
      se: '/first-member-medlemsvillkor',
      dk: '/first-member-medlemsvilkaar',
    },
    '/first-member/first-member-terms-conditions': {
      en: '/first-member/first-member-terms-conditions',
      no: '/first-member/first-member-vilkaar',
      se: '/first-member/first-member-medlemsvillkor',
      dk: '/first-member/first-member-medlemsvilkaar',
    },
    '/pricematch': '/pricematch',
    '/faq': '/faq',
    '/first-member': '/first-member',
    '/login': '/login',
    '/account': '/account',
  },
})
